import axios, { AxiosError, isAxiosError } from "axios";
import { API_URL } from "../utils/constants";
import { toast } from "sonner";

export const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (isAxiosError(error) && error.status === 401) {
      toast.error("Session expired", {
        richColors: true,
      });
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);
